import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import "./armeria.css";

/**
 * Layout wrapper for all La Armería pages. Provides the dark charcoal + gold
 * palette, back link to /armeria index, and consistent header.
 */
export default function ArmeriaLayout({ children, title, subtitle, showBack = true }) {
  const navigate = useNavigate();
  return (
    <div className="armeria-root">
      <header style={{
        borderBottom: "1px solid rgba(200,146,42,0.22)",
        padding: "18px 24px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        background: "rgba(0,0,0,0.3)",
        backdropFilter: "blur(8px)",
        position: "sticky", top: 0, zIndex: 100
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          {showBack && (
            <button
              onClick={() => navigate(-1)}
              className="arm-btn-outline"
              style={{ padding: "6px 12px", fontSize: "13px", display: "inline-flex", alignItems: "center", gap: "4px" }}
              data-testid="armeria-back-btn"
            >
              <ArrowLeft size={14} /> Volver
            </button>
          )}
          <Link to="/armeria" style={{ textDecoration: "none", color: "#c8922a", fontFamily: "'Playfair Display', serif", fontSize: "20px", fontWeight: 700 }}>
            La Armería
          </Link>
        </div>
        <Link to="/" style={{ color: "#a89b83", fontSize: "13px", textDecoration: "none", fontFamily: "'DM Sans', sans-serif" }}>
          La Forja de Contenidos ↗
        </Link>
      </header>

      <div className="arm-container">
        {title && (
          <div style={{ marginBottom: "32px" }}>
            <span className="arm-badge">Herramienta gratuita</span>
            <h1 style={{ fontSize: "42px", margin: "12px 0 8px", lineHeight: "1.1" }}>{title}</h1>
            {subtitle && <p style={{ color: "#a89b83", fontSize: "17px", lineHeight: "1.5", maxWidth: "700px" }}>{subtitle}</p>}
          </div>
        )}
        {children}
      </div>

      <footer style={{
        borderTop: "1px solid rgba(200,146,42,0.15)",
        padding: "24px",
        marginTop: "48px",
        textAlign: "center",
        color: "#a89b83",
        fontSize: "12px",
        fontFamily: "'IBM Plex Mono', monospace"
      }}>
        La Armería · El Maestro Armero · 100% gratuita · Parte de La Forja de Contenidos
      </footer>
    </div>
  );
}
